const megaMenu = document?.querySelector(".mega-menu");
const mobileMenu = document?.querySelector(".mobile-menu-wrapper");
const mobileMenuWrapper = mobileMenu?.querySelector(".mobile-menu");
const mobileMenuBtn = document?.querySelector(".mega-menu .open-menu");
const mobileMenuClose = document?.querySelector(".mega-menu .close-menu");
const searchBtn = megaMenu?.querySelector(".icon-search");
const body = document?.querySelector("body");
const backBtn = megaMenu?.querySelector(".back-btn");

const mobileMenuLinks = megaMenu?.querySelectorAll(
  ".mobile-menu-wrapper .dropdown-link"
);

mobileMenuBtn?.addEventListener("click", function () {
  mobileMenu?.classList?.add("active");
  megaMenu?.classList?.add("menu-opened");
  body.style.overflow = "hidden";
});

searchBtn?.addEventListener("click", function () {
  mobileMenu?.classList?.add("active");
  megaMenu?.classList?.add("menu-opened");
  body.style.overflow = "hidden";
  const searchInput = mobileMenuWrapper?.querySelector(
    ".search .search__input"
  );
  if (searchInput) {
    searchInput.focus();
  }
});
mobileMenuClose?.addEventListener("click", function () {
  const activeLink = megaMenu?.querySelector(".dropdown-link.active");
  mobileMenu?.classList?.remove("active");
  megaMenu?.classList?.remove("menu-opened");
  megaMenu?.classList?.remove("submenu-opened");
  activeLink?.classList?.remove("active");
  body.style.overflow = "auto";
});

mobileMenu?.addEventListener("click", function () {
  const activeLink = megaMenu?.querySelector(".dropdown-link.active");
  mobileMenu?.classList?.remove("active");
  megaMenu?.classList?.remove("menu-opened");
  megaMenu?.classList?.remove("submenu-opened");
  activeLink?.classList?.remove("active");
  body.style.overflow = "auto";
});

mobileMenuWrapper?.addEventListener("click", function (e) {
  e?.stopPropagation();
});

mobileMenuLinks?.forEach((item) => {
  item?.addEventListener("click", function () {
    item?.classList?.add("active");
    megaMenu?.classList?.add("submenu-opened");
  });
});

backBtn?.addEventListener("click", function () {
  const activeLink = megaMenu?.querySelector(".dropdown-link.active");
  activeLink?.classList?.remove("active");
  megaMenu?.classList?.remove("submenu-opened");
});
